<div
  [ngClass]="{
    'logo-small': variant === 'small',
    'logo-full': variant === 'full',
    'logo-dark': color === 'dark',
    'logo-light': color === 'light'
  }"
></div>
